import { apiRequest} from './index'

export const getPaymentsRequest = (filters) => {
  const {
    page='',
    limit='',
    search='',
    status='',
    client='',
    seller='',
    type='',
    subtype='',
    start_date='',
    end_date='',
    direction='',
    simplified='true',
    project=''
  } = filters;

  return apiRequest(
    `/admin/payments?page=${page}&limit=${limit}&search=${search}&status=${status}&client=${client}&seller=${seller}&type=${type}&subtype=${subtype}&startDate=${start_date}&endDate=${end_date}&direction=${direction}&simplified=${simplified}&project=${project}`,
    {
      method: 'GET'
    },
    true
  )
}

export const getPaymentRequest = (id) => {
  return apiRequest(
    `/admin/payments/${id}`,
    {
      method: 'GET'
    },
    true
  )
}

export const updatePaymentRequest = (payment) => {
  return apiRequest(
    `/admin/payments/${payment._id}`,
    {
			method: 'PUT',
			body: JSON.stringify(payment)
    },
    true
  )
}

export const createPaymentRequest = (payment) => {
  return apiRequest(
    `/admin/payments`,
    {
			method: 'POST',
			body: JSON.stringify(payment)
    },
    true
  )
}

export const deletePaymentRequest = (paymentId) => {
  return apiRequest(
    `/admin/payments/${paymentId}`,
    {
			method: 'DELETE'
    },
    true
  )
}

export const markPaymentsAsPaid = (data) => {
  return apiRequest(
    `/admin/payments/mark-as-paid`,
    {
			method: 'POST',
      body: JSON.stringify(data)
    },
    true
  )
}

export const getPaymentStatsForSOARequest = (clientId) => {
  return apiRequest(
    `/admin/payments/stats/soa/${clientId}`,
    {
      method: 'GET'
    },
    true
  )
}
